<div class="game-panel-container w-100 d-flex flex-column align-items-center">
  <div class="game-details d-flex flex-column w-100">
    <ng-container *ngIf="isFutureGame; else currentGameDetails">
      <div class="game-window-time text-black future-game font-size-12 d-flex flex-row align-items-center justify-content-center">
        {{ 'fantasy.game.window.opens' | translate }}
        <fgbcl-countdown
          class="font-size-12 fw-bold"
          [endDateTime]="games[0].StartDate"
          [displayMinutes]="true"
        ></fgbcl-countdown>
      </div>
    </ng-container>
    <ng-template #currentGameDetails>
      <div class="game-window-time font-size-12 d-flex flex-row align-items-center justify-content-center">
        {{ 'fantasy.game.window.closes' | translate }}
        <fgbcl-countdown
          class="font-size-12 fw-bold"
          [endDateTime]="games[0].EndDate"
          [displayMinutes]="true"
          (complete)="onGameEnds($event)"
        ></fgbcl-countdown>
      </div>
    </ng-template>

    <div class="teams-container d-flex flex-column align-items-center bg-primary">
      <div class="teams-details">
        <div class="team-item home-team d-flex flex-row align-items-center">
          <p class="team-name font-size-14 fw-bold text-white text-capitalize mb-0 text-end">{{ games[0].HomeTeamName }}</p>
          <ng-container *ngIf="games[0].HomeTeamLogo; else noHomeImage">
            <img src="{{ games[0].HomeTeamLogo | contentImage: '7' }}" alt="home team" />
          </ng-container>
          <ng-template #noHomeImage>
            <img [src]="'placeholders/fallbackteamlogo.svg' | contentAssetImage" alt="home team" />
          </ng-template>
        </div>
        <span class="vs-text font-size-14 fw-bold text-white text-uppercase">{{ 'fantasy.game.vs' | translate }}</span>
        <div class="team-item away-team d-flex flex-row align-items-center">
          <ng-container *ngIf="games[0].AwayTeamLogo; else noAwayImage">
            <img src="{{ games[0].AwayTeamLogo | contentImage: '7' }}" alt="away team" />
          </ng-container>
          <ng-template #noAwayImage>
            <img [src]="'placeholders/fallbackteamlogo.svg' | contentAssetImage" alt="home team" />
          </ng-template>
          <p class="team-name font-size-14 fw-bold text-white text-capitalize mb-0 text-start">{{ games[0].AwayTeamName }}</p>
        </div>
      </div>

      <p class="font-size-12 text-white mb-0">{{ gameTime }}, {{ gameDate }}</p>
    </div>
  </div>
</div>

<div
  *ngIf="games[0].Sponsor?.SponsorId"
  class="sponsor-container w-100 d-flex flex-row align-items-center justify-content-center text-white font-size-12"
>
  {{ 'fantasy.game.sponsored.by' | translate }}
  <ng-container *ngIf="games[0].Sponsor?.SponsorImage; else brokenImg">
    <img src="{{ games[0].Sponsor.SponsorImage | contentImage: '1' }}" alt="{{ games[0].Sponsor?.SponsorText }}" />
  </ng-container>
  <ng-template #brokenImg><span class="material-symbols-outlined"> broken_image </span></ng-template>
</div>

<ng-container *ngIf="!isFutureGame">
  <fgb-fantasy-player-select
    [gameEnds]="gameEnds"
    [gameDetails]="gameDetails"
    [gameId]="games[0].GameId"
  ></fgb-fantasy-player-select>
</ng-container>
